import { testEmpty, convertToNumber } from '@iso/lib/helpers/utility';

export function testNumber(n) {
    return (typeof n !== 'undefined') ? ((typeof n === 'string') ? convertToNumber(testEmpty(n, '0')) : testEmpty(n, 0)) : 0;
}